module.exports = __webpack_public_path__ + "static/media/generic_school.12f98bf5.jpg";